<template>

<app-input :wide="wide" :messages="messages" :locked="locked" :prefix="prefix" :label="label" :stacked="stacked" :no-line="noLine" :notes="notes" :disabled="disabled" :validation="validation">

    <div v-tooltip="'Click to pick'" class="picker-text" v-on:click="onPickerClick">{{ valueText }}</div>

    <app-icon icon="pick" class="picker-icon" />

</app-input>
        
</template>

<script>

export default {

	props: ['label', 'wide', 'text', 'messages', 'locked', 'loading', 'prefix', 'validation', 'numeric', 'autogrow', 'disabled', 'value', 'noLine', 'stacked', 'placeholder', 'notes'],

    data: function() {
    
        return {
            is: {
                picking: false
            }        
        }
    
    },

    computed: {
    
        valueText: function() {
        
            return (this.value) ? this.text : this.placeholder
        
        }

    },

    methods: {
    
        onPickerClick: function() {

            this.is.picking = true

            this.$pubsub.$on('picker.confirmed', this.onPickerConfirmed)
            this.$pubsub.$on('picker.closed', this.onPickerClosed)
        
            this.$emit('picker', {
                value: this.value
            })
        
        },

        onPickerConfirmed: function(e) {

            this.$emit('input', e.value)

        },

        onPickerClosed: function() {

            if(this.is.picking) {

                this.$pubsub.$off('picker.confirmed', this.onPickerConfirmed)
                this.$pubsub.$off('picker.closed', this.onPickerClosed)

                this.is.picking = false

            }

        }
    
    }

}

</script>

<style scoped>

.picker-text {
	line-height: 36px;
	font-size: 14px;
	width: 100%;
	padding: 0px 10px;
	color: #333;
	background-color: #fff;
	border-radius: 10px;
	border: 2px solid #eee;
}

.picker-text:hover {
	border-color: #4082d3;
    cursor: pointer;
}

.picker-icon {
	color: #ddd;
	position: absolute;
	right: 12px;
	top: 12px;
	font-size: 16px;
}

</style>
